/**
 * Hours, written the way a person writes them.
 *
 * This exists because three files each grew their own version and one of them
 * was wrong in a way nobody would spot by reading it:
 *
 *   `Number(v).toFixed(2).replace(/\.00$/, '').replace(/0$/, '')`
 *
 * The first replace turns "10.00" into "10". The second is meant to turn
 * "9.50" into "9.5" - but it has already been handed "10", so it strips that
 * zero too and renders ten hours as 1h. Twenty became 2h, a hundred became
 * 10h, and zero became a bare "h". Every round multiple of ten, on the figure
 * a contractor invoices against.
 *
 * Rounding to two places and back through Number does the whole job: it drops
 * trailing zeros only where they are after a decimal point, which is the rule
 * anyone would have stated if asked.
 */

/** 3 -> "3", 9.5 -> "9.5", 10 -> "10", 2.25 -> "2.25" */
export function hoursValue(v) {
  const n = Number(v);
  return Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
}

/** The same, with the unit, for display. */
export function hours(v) {
  return `${hoursValue(v)}h`;
}

/** A signed figure, for a variance where the direction is the point. */
export function hoursDelta(v) {
  const n = hoursValue(v);
  return n === 0 ? '—' : `${n > 0 ? '+' : ''}${n}`;
}
